import { ReportStatuses } from '@schooly/api';

export function getReportStatusTextId(status: ReportStatuses) {
  switch (status) {
    case ReportStatuses.Published:
      return 'status-Published';
    case ReportStatuses.Draft:
      return 'status-Draft';
    case ReportStatuses.Unpublished:
      return 'status-NotPublished';
  }
}
